// import React from "react";
import axios from "axios";
import { BE_API_DOCUMENT_API, utils } from "../../../../utils/globalVariables";

const tandaTerimaApi = {

    fetchData: async ({ stateData }) => {
        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', stateData.loginContextSyswebapp);
        formDT.append('flag_all', utils.flagAll);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_step', stateData.projectStep);
        formDT.append('project_is_cancel', stateData.projectIsCancel);

        try {
            const response = await axios({
                method: 'post',
                url: BE_API_DOCUMENT_API + '/get_tanda_terima',
                data: formDT,
                headers: formDTHeader,
                cancelToken: stateData.cancelToken // Menggunakan token pembatalan dalam permintaan
            });

            return response.data;
        } catch (error) {
            // Mengecek apakah error adalah hasil pembatalan atau bukan
            if (axios.isCancel(error)) {
                // konsol . log('Request canceled:', error.message);
            } else {
                throw error;
            }
        }
    }
};

export default tandaTerimaApi;